import React from 'react';
import Editor from '@monaco-editor/react';

export default function CPBuilder({
	selectedQuery,
	handleQuerySelect,
	isNewQuery,
	setIsNewQuery,
	queryType,
	setQueryType,
	queryDescription,
	setQueryDescription,
	queryText,
	setQueryText,
	availableQueryTypes,
	idTypes,
	idType,
	setIdType,
	returnType,
	setReturnType,
	submitCounterparty,
	CounterpartyList

}) {
    return (
	  <form className="p-5 mb-10 ml-5 bg-white shadow" onSubmit={submitCounterparty}>
			  <h2 className="bg-purple-l border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-md">
				  Counterparty Query Builder
			  </h2>
			  <div className="flex flex-col justify-center px-6 mt-5">
				<label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="newQuery">New Query</label>
				<input type="checkbox" className="form-checkbox mx-2 h-4 w-4" defaultChecked={isNewQuery} onChange={(e) => setIsNewQuery(!isNewQuery)}/>
			  </div>
			  <div className="flex flex-col justify-center px-6 mt-5">
				<label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="qType">Query Type</label>
				<select
				  className="appearance-none border rounded w-2/3 py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
				  id="qType"
				  placeholder="MySQL"
				  value={queryType}
				  onChange={(event) => setQueryType(event.target.value)}
				>
				  <option value="MYSQL">MySQL</option>
				  <option value="NEO4J">Neo4j</option>
				  <option value="MONGO">Mongo</option>
				</select>
	                  </div>
			  {!isNewQuery && (
				  <>
					  <div className="flex flex-col justify-center px-6 mt-5">
							<label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="recurrence">Query</label>
							<select
							  className="appearance-none border rounded w-2/3 py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
							  id="query"
							  placeholder={"Select Query to Modify"}
							  value={selectedQuery.i}
							  onChange={handleQuerySelect}
				                          >
							  {CounterpartyList.map((query, i) => (
								  <option value={i}>{query.QueryDescription}</option>
							  ))}
							</select>
					  </div>
				  </>
			  )}
			  <div className="flex flex-col justify-center px-6 mt-5">
				<label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="qDescription">
				  Description
				</label>
				<input
				  className="appearance-none border rounded w-2/3 py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
				  type="text"
				  id="qDescription"
				  value={queryDescription}
				  onChange={(event) => setQueryDescription(event.target.value)}
				/>
			  </div>
			  <div className="flex flex-col justify-center px-6 mt-5">
				<label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="sql">SQL:</label>
				<Editor
				  height="25vh"
				  defaultLanguage="mysql"
			          theme="github"
				  defaultValue=""
	                          value={queryText}
				  onChange={(value, event) => setQueryText(value)}
				/>
			  </div>
			  <div className="flex flex-col justify-center px-6 mt-5">
				<label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="availableQueryTypes">Id Type</label>
				<select
				  className="appearance-none border rounded w-2/3 py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
				  id="availableQueryTypes"
				  placeholder="Party"
				  value="counterparty"
				  onChange={(event) => setIdType(event.target.value)}
				>
					<option value="counterparty">Counterparty</option>
				</select>
			  </div>
			  <div className="flex flex-col justify-center px-6 mt-5">
				<label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="qReturnType">Query Return Type</label>
				<select
				  className="appearance-none border rounded w-2/3 py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
				  id="qReturnType"
				  placeholder="Number"
				  value={returnType}
				  onChange={(event) => setReturnType(event.target.value)}
				>
				  {availableQueryTypes.map(queryReturnType => (
					  <option value={queryReturnType}>{queryReturnType}</option>
				  ))}
				</select>
			  </div>
			  <button className="text-gray-800 bg-white mt-3 ml-5 hover:text-purple-500 font-semibold py-2 px-4 border border-gray-400 rounded shadow" type="submit">Submit</button>
		</form>
    )
}
